import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "skip-next",
  "use": "skip-next-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"skip-next\"><path d=\"M6 18l8.5-6L6 6v12zM16 6v12h2V6h-2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol